import React from 'react';
import axios from '../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

const searchQueryId = window?.Livewire?.request?.searchQuery?.id || 0;

export function useGetWiresFromContributor(contributorId, filterWires, limit) {
  return useAxios({
    method: 'GET',
    url: `/api/v1/wires/contributor/${contributorId}`,
    params: {
      // eslint-disable-next-line camelcase
      filter_wires: filterWires,
      top: limit,
      search_query_id: searchQueryId,
    },
  }, { manual: true });
}

const params = page => ({ params: { page, search_query_id: searchQueryId } });

export function useGetPaginatedWiresFromContributor(contributorId) {
  const [state, q] = useAxios({
    url: `/api/v1/wires/contributor/${contributorId}`,
    method: 'GET',
    ...params(1),
  }, { manual: true });
  const executeQuery = React.useCallback(page => q(params(page)), [q]);
  return [state, executeQuery];
}

export function useGetPaginatedAllWiresOfContributor(contributorId) {
  const [state, q] = useAxios({
    url: `/api/v1/wires/contributor/${contributorId}/all`,
    method: 'GET',
    ...params(1),
  }, { manual: true });
  const executeQuery = React.useCallback(page => q(params(page)), [q]);
  return [state, executeQuery];
}

export function useGetPaginatedAllWiresOfFund(fundId) {
  const [state, q] = useAxios({
    url: `/api/v1/wires/fund/${fundId}/all`,
    method: 'GET',
    ...params(1),
  }, { manual: true });
  const executeQuery = React.useCallback(page => q(params(page)), [q]);
  return [state, executeQuery];
}

export function useGetPaginatedWiresMentioningContributor(contributorId) {
  const [state, q] = useAxios({
    url: `/api/v1/wires/mention_of/contributor/${contributorId}`,
    method: 'GET',
    ...params(1),
  }, { manual: true });
  const executeQuery = React.useCallback(page => q(params(page)), [q]);
  return [state, executeQuery];
}
